import React from "react";
import PublicFeatureLandingPage from "../../components/common/PublicFeatureLandingPage";
import { RegisterBusinessDialog } from "../../components/business/business/businessSettings";
import { buildBusinessRegisterShareMessage } from "../../util/publicShareMessages";

const SHARE_PATH = "/business/register";
const LOGIN_PATH = `/login?returnTo=${encodeURIComponent("/biz/business?v=care")}`;

export default function BusinessRegisterPublicPage() {
  const [dialogOpen, setDialogOpen] = React.useState(false);

  return (
    <>
      <PublicFeatureLandingPage
        path={SHARE_PATH}
        seoTitle="Update Your Care Listing | Plany365"
        seoDescription="Update or claim your care listing on Plany365 to improve your profile, attract referrals, schedule tours, and manage growth."
        eyebrow="Care Listing"
        title="Update your care listing and receive referrals"
        description="Update or claim your care profile on Plany365 so families, hospitals, agencies, and social workers can find you, send referral requests, and move qualified leads toward tours and move-ins."
        highlights={[
          "Update your care listing or claim an existing public profile.",
          "Position your home or community to attract referrals from families and referral partners.",
          "Show care levels, amenities, business details, and availability to build trust faster.",
          "Once live, manage referrals, tours, residents, staff, and care operations in one workspace.",
        ]}
        actions={[
          {
            label: "Update Your Care Listing",
            onClick: () => setDialogOpen(true),
            variant: "contained",
          },
          {
            label: "I already have an account",
            href: LOGIN_PATH,
            variant: "outlined",
          },
        ]}
        buildShareMessage={buildBusinessRegisterShareMessage}
        shareDescription="Use this message when you want to invite a care business owner or administrator to update their listing and start receiving referrals on Plany365."
      />

      <RegisterBusinessDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        source="public-business-register"
        verticalId="care"
        title="Update your care listing"
      />
    </>
  );
}
